import ApiService from "../../../services/ApiService";
import translate from "../../../services/Translate";

export const fetchPrecorrectionAccuracy = (
  startDate: string | null,
  endDate: string | null,
  setPrecorrectionAccuracy: Function,
  setLoading: Function,
  language: string
) => {
  setLoading(true);

  let url = "insights/precorrection-accuracy";
  const params = new URLSearchParams();
  if (startDate) params.append("start_date", startDate);
  if (endDate) params.append("end_date", endDate);
  if (Array.from(params).length > 0) {
    url += `?${params.toString()}`;
  }

  ApiService.get(url)
    .then((response) => setPrecorrectionAccuracy(response.data))
    .catch((error) => {
      setPrecorrectionAccuracy(null);
      alert(translate(language, "PAGES.INSIGHTS.EVALUATION_ACCURACY.ERROR"));
      console.error("An error occurred on fetching pre-correction accuracy", error);
    })
    .finally(() => setLoading(false));
};

export const getAvailableStatisticsTypes = (data: any): string[] => {
  if (!data?.precorrection_accuracy?.statistics) {
    return ["overall"];
  }

  return Object.keys(data.precorrection_accuracy.statistics);
};

export const getChartData = (stats: any, language: string) => {
  if (!stats.total_attempts) return [];

  return [
    {
      metric: translate(language, "PAGES.INSIGHTS.EVALUATION_ACCURACY.GRAPH.SUCCESS"),
      value: stats.correct_precorrection,
      percentage: stats.precorrection_accuracy,
      color: "var(--color-dark-green)",
    },
    {
      metric: translate(language, "PAGES.INSIGHTS.EVALUATION_ACCURACY.GRAPH.FAILED"),
      value: stats.total_attempts - stats.correct_precorrection,
      percentage: 100 - stats.precorrection_accuracy,
      color: "var(--color-dark-red)",
    },
  ];
};
